/*
 * COPYRIGHT Motorola Solutions, INC.
 * ALL RIGHTS RESERVED.
 * MOTOROLA SOLUTIONS CONFIDENTIAL RESTRICTED
 */

import { Inject, Injectable, RendererFactory2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { fetchSkipperLocationConfiguration, receivedLocationEvent } from '../+state/location.actions';
import { DOCUMENT } from '@angular/common';
import { LocationEvent } from '../model/location';
import { filter } from 'rxjs/operators';
import { selectLocationEffectInitialized } from '../+state/location.selectors';
import { StompBaseConsumer } from '../../core/abstract/stomp-base-consumer';
import { StompManagerService } from '../../core/services/stomp-manager/stomp-manager.service';
import { Topic } from '../../user/model/multiple-subscriptions';

@Injectable({
    providedIn: 'root'
})
export class LocationService extends StompBaseConsumer {

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private rendererFactory: RendererFactory2,
        protected store: Store,
        protected stompManager: StompManagerService
    ) {
        super(stompManager, store);
            this.store
            .select(selectLocationEffectInitialized)
            .pipe(filter((init) => init))
            .subscribe(() => this.store.dispatch(fetchSkipperLocationConfiguration()));
    }

    protected handleLocationEventMessage(locationEvent: LocationEvent) {
        this.store.dispatch(receivedLocationEvent({ locationEvent }));
    }

    protected getTopics(): Topic[] {
        return [Topic.LOCATION];
    }

    protected getTopicHandlers(): { [p in Topic]?: (message: any) => void } {
        return {
            [Topic.LOCATION]: this.handleLocationEventMessage.bind(this),
        };
    }

    handleSubscriptionInit(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Location topic ${topic} subscription success: ${receiptId}`);
    }

    handleSubscriptionEnd(topic: string, receiptId: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Location topic ${topic} subscription end: ${receiptId}`);
    }

    handleStompError(topic: string, receiptId: string, error: string, clusterName?: string, clusterLabel?: string): void {
        console.info(`${clusterLabel ? clusterLabel : ''} Location topic ${topic} subscription failed=${error} for receiptId=${receiptId}`);
    }

    public createScriptTag(script: string) {
        let renderer = this.rendererFactory.createRenderer(null, null);
        const precompiledTemplates = renderer.createElement('script');
        precompiledTemplates.type = 'text/javascript';
        precompiledTemplates.text = script;
        renderer.appendChild(this.document.body, precompiledTemplates);
    }
}
